import React from 'react';
import { css } from '@emotion/react';

const BallAnimation = () => {
  const styles = css`
    .sphere-container {
      position: relative;
      width: 40px;
      height: 40px;
    }

    .crystal-sphere {
      position: absolute;
      width: 100%;
      height: 100%;
      border-radius: 50%;
      box-shadow:
        inset 0 0 20px rgba(255, 255, 255, 0.2),
        0 0 5px rgba(255, 255, 255, .1);
      animation: flowing 4s linear forwards;
      animation-iteration-count: infinite;
      animation-timing-function: ease-in-out;
    }

    .outer-sphere {
      position: absolute;
      width: 100%;
      height: 100%;
      border-radius: 50%;
      background: linear-gradient(135deg,
          rgba(0, 255, 132, 0) 100%,
          rgba(0, 255, 132, 0.4) 50%,
          rgba(0, 255, 132, 0.2) 0%);
      backdrop-filter: blur(4px);
      box-shadow: 4px 4px 6px rgba(20, 225, 132, 0.4);
    }

    .middle-sphere {
      position: absolute;
      width: 100%;
      height: 100%;
      border-radius: 50%;
      radial-gradient(#fff 100%, #CDF9E4 40%);
      // border: 1px solid rgba(255, 255, 255, 0.05);
      box-shadow: inset -2px -2px 0px rgba(255, 255, 255,1);
    }

    .inner-sphere {
      position: absolute;
      width: 100%;
      height: 100%;
      border-radius: 50%;
      overflow: hidden;
      /* Add this inner shadow */
      box-shadow: inset -15px -15px 8px rgba(96, 243, 117, .4);
    }

    .color-blend-1 {
      position: absolute;
      width: 120%;
      height: 120%;
      top: -10%;
      left: -10%;
      background: radial-gradient(circle at center,
          rgba(107, 228, 172, 1) 0%,
          rgba(107, 228, 172, 0) 70%);
      filter: blur(5px);
      animation: moveColors1 4s ease-in-out infinite;
    }
    .color-blend-2 {
      position: absolute;
      width: 110%;
      height: 110%;
      top: -10%;
      left: -10%;
      background: radial-gradient(circle at center,
          rgba(0, 190, 255, 0.6) 0%,
          rgba(0, 190, 255, 0) 70%);
      filter: blur(5px);
      animation: moveColors2 8s ease-in-out infinite;
    }
    .color-blend-3 {
      position: absolute;
      width: 90%;
      height: 90%;
      top: -10%;
      left: -10%;
      background: radial-gradient(circle at center,
          rgba(242, 213, 131, 0.8) 0%,
          rgba(242, 213, 131, 0) 70%);
      filter: blur(5px);
      animation: moveColors3 6s ease-in-out infinite;
    }
    .surface-highlights {
      position: absolute;
      width: 100%;
      height: 100%;
      border-radius: 50%;
      background:
        radial-gradient(circle at 20% 20%,
          rgba(255, 255, 255, 0.8) 0%,
          transparent 50%),
        radial-gradient(circle at 80% 80%,
          rgba(255, 255, 255, 0.2) 0%,
          transparent 0%);
      pointer-events: none;
    }
    .thickness-ring {
      position: absolute;
      width: 110%;
      height: 100%;
      top: 2%;
      left: -4%;
      border-radius: 50%;
      border: 6px solid rgba(255, 255, 255, .5);
      filter: blur(6px);
    }
    .shadow {
      position: absolute;
      width: 100%;
      height: 6px;
      background: radial-gradient(ellipse at center,
          rgba(0, 0, 0, 0.2) 0%,
          transparent 100%);
      border-radius: 50%;
      bottom: -15px;
      filter: blur(5px);
    }
    @keyframes moveColors1 {
      0%,
      100% {
        transform: translate(-30%, -30%) rotate(0deg);
      }

      50% {
        transform: translate(30%, 30%) rotate(180deg);
      }
    }
    @keyframes moveColors2 {
      0%,
      100% {
        transform: translate(30%, -30%) rotate(180deg);
      }

      50% {
        transform: translate(-30%, 30%) rotate(0deg);
      }
    }
    @keyframes moveColors3 {
      0%,
      100% {
        transform: translate(0%, 40%) rotate(90deg);
      }

      50% {
        transform: translate(40%, 0%) rotate(270deg);
      }
    }
    @keyframes flowing {
      0% {
        transform: translateY(0);
      }
      50% {
        transform: translateY(10%);
      }
      100% {
        transform: translateY(0);
      }
    }

    .star {
      animation: fade 3s ease-in-out infinite;
    }

    #star1 { transform: translateX(-10px) translateY(5px); }
    #star2 { transform: translateX(10px) translateY(5px); }
    #star3 { transform: translateX(-20px) translateY(-5px); animation-duration: 5s; }
    #star4 { transform: translateX(20px) translateY(-5px); animation-duration: 5s; }
    @keyframes fade {
      0%, 100% { opacity: 0.2; }
      50% { opacity: 1; }
    }

  `;

  return (
    <div css={styles}>
      <div className='ball-animation d-flex align-items-center justify-content-center m-0'>
        <svg className='star' id='star3' width='8' height='8' viewBox='0 0 8 8' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <path d='M7.67421 0.586315L5.13867 4.12185L7.67421 7.65738L4.13867 5.12185L0.603138 7.65738L3.13867 4.12185L0.603138 0.586315L4.13867 3.12185L7.67421 0.586315Z' fill='url(#paint0_linear_823_186881)' />
          <defs>
            <linearGradient id='paint0_linear_823_186881' x1='-2.9324' y1='4.12185' x2='11.1596' y2='4.96241' gradientUnits='userSpaceOnUse'>
              <stop stopColor='#60F3AB' />
              <stop offset='0.45' stopColor='#00CCBC' />
              <stop offset='1' stopColor='#009AC0' />
            </linearGradient>
          </defs>
        </svg>
        <svg className='star' id='star1' width='17' height='16' viewBox='0 0 17 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <path d='M8.08841 0L9.21978 6.86863L16.0884 8L9.21978 9.13137L8.08841 16L6.95704 9.13137L0.0884094 8L6.95704 6.86863L8.08841 0Z' fill='url(#paint0_linear_823_186882)' />
          <defs>
            <linearGradient id='paint0_linear_823_186882' x1='0.0884094' y1='16' x2='16.9827' y2='1.00771' gradientUnits='userSpaceOnUse'>
              <stop stopColor='#60F3AB' />
              <stop offset='0.45' stopColor='#00CCBC' />
              <stop offset='1' stopColor='#009AC0' />
            </linearGradient>
          </defs>
        </svg>
        <div className='sphere-container'>
          <div className='shadow' />
          <div className='crystal-sphere'>
            <div className='outer-sphere'>
              <div className='thickness-ring' />
              <div className='middle-sphere'>
                <div className='inner-sphere'>
                  <div className='color-blend-1' />
                  <div className='color-blend-2' />
                  <div className='color-blend-3' />
                </div>
                <div className='thickness-ring' />
              </div>
              <div className='surface-highlights' />
            </div>
          </div>
        </div>
        <svg className='star' id='star2' width='17' height='16' viewBox='0 0 17 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <path d='M8.08841 0L9.21978 6.86863L16.0884 8L9.21978 9.13137L8.08841 16L6.95704 9.13137L0.0884094 8L6.95704 6.86863L8.08841 0Z' fill='url(#paint0_linear_823_186882)' />
          <defs>
            <linearGradient id='paint0_linear_823_186882' x1='0.0884094' y1='16' x2='16.9827' y2='1.00771' gradientUnits='userSpaceOnUse'>
              <stop stopColor='#60F3AB' />
              <stop offset='0.45' stopColor='#00CCBC' />
              <stop offset='1' stopColor='#009AC0' />
            </linearGradient>
          </defs>
        </svg>
        <svg className='star' id='star4' width='8' height='8' viewBox='0 0 8 8' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <path d='M7.67421 0.586315L5.13867 4.12185L7.67421 7.65738L4.13867 5.12185L0.603138 7.65738L3.13867 4.12185L0.603138 0.586315L4.13867 3.12185L7.67421 0.586315Z' fill='url(#paint0_linear_823_186881)' />
          <defs>
            <linearGradient id='paint0_linear_823_186881' x1='-2.9324' y1='4.12185' x2='11.1596' y2='4.96241' gradientUnits='userSpaceOnUse'>
              <stop stopColor='#60F3AB' />
              <stop offset='0.45' stopColor='#00CCBC' />
              <stop offset='1' stopColor='#009AC0' />
            </linearGradient>
          </defs>
        </svg>
      </div>
    </div>
  );
};
export default BallAnimation;
